(function () {
  document.querySelectorAll('.lp-faq__question').forEach(function (button) {
    button.addEventListener('click', function () {
      var expanded = button.getAttribute('aria-expanded') === 'true';
      var answer = document.getElementById(button.getAttribute('aria-controls'));

      button.setAttribute('aria-expanded', String(!expanded));
      if (answer) answer.classList.toggle('is-open', !expanded);
    });
  });
})();
